import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconExperiment';
/** Renders an SVG icon. */
const SvgExperiment = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M26 24.677c0-.252-.072-.499-.207-.711L21.997 18H10.003l-3.796 5.966A1.325 1.325 0 0 0 7.323 26h17.354c.73 0 1.323-.593 1.323-1.323M20 22a1 1 0 1 0-2 0 1 1 0 0 0 2 0M19 6h-6v5.253a7 7 0 0 1-1.095 3.758l-.63.989h9.45l-.63-.99A7 7 0 0 1 19 11.254zm3 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1-10.747a5 5 0 0 0 .781 2.684l5.7 8.956A3.324 3.324 0 0 1 24.677 28H7.323a3.323 3.323 0 0 1-2.803-5.107l5.699-8.956A5 5 0 0 0 11 11.253V6a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2z"
      />
      <path fill="currentColor" d="M12 24a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </svg>
  );
};
SvgExperiment.displayName = displayName;
export default SvgExperiment;
